import type { TranslateFn } from './TranslateFn'

/**
 * `useI18n()` requires an active component `setup()` context. Pinia store
 * actions/getters run outside that call stack, so they resolve the
 * translator through Nuxt's app instance instead, which has no such
 * restriction and works identically for components and stores.
 */
export function usePresentationTranslator(): TranslateFn {
  const { $i18n } = useNuxtApp()

  return (key, params) => (params === undefined ? $i18n.t(key) : $i18n.t(key, params))
}
